function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import styled, { css } from 'styled-components';
import React, { useEffect, useState } from 'react';
import { themeLight, spacing, icons } from '@naf/theme';
import { propValidationConfig } from './propValidationConfig';
var NavbarVariant = /*#__PURE__*/function (NavbarVariant) {
  NavbarVariant["Default"] = "default";
  NavbarVariant["White"] = "white";
  return NavbarVariant;
}(NavbarVariant || {});
export const MenuButton = ({
  label,
  isOpen = false,
  ariaLabel,
  variant,
  ...props
}) => {
  const [mouseDown, setMouseDown] = useState(false);
  const removeOutline = () => {
    setMouseDown(true);
  };
  const addOutline = e => {
    if (e.key === 'Tab') {
      setMouseDown(false);
    }
  };
  useEffect(() => {
    window.addEventListener('mousedown', removeOutline);
    return () => window.removeEventListener('mousedown', removeOutline);
  }, []);
  useEffect(() => {
    window.addEventListener('keydown', addOutline);
    return () => window.removeEventListener('keydown', addOutline);
  }, []);
  return /*#__PURE__*/React.createElement(Btn, _extends({
    id: mouseDown ? 'mousedown' : '',
    "aria-label": ariaLabel
  }, props), label && /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(Burger, {
    $variant: variant
  }, /*#__PURE__*/React.createElement(Line, {
    $first: true,
    $variant: variant,
    $isOpen: isOpen
  }, /*#__PURE__*/React.createElement(Span, {
    $variant: variant
  })), /*#__PURE__*/React.createElement(Line, {
    $second: true,
    $variant: variant,
    $isOpen: isOpen
  }), /*#__PURE__*/React.createElement(Line, {
    $third: true,
    $variant: variant,
    $isOpen: isOpen
  }, /*#__PURE__*/React.createElement(Span, {
    $variant: variant
  }))));
};
export default MenuButton;
const speedIn = '.15s';
const speedOut = '.15s';
const easeIn = 'ease';
const easeOut = 'ease';
const Btn = styled.button.withConfig({
  displayName: "menu-button__Btn",
  componentId: "sc-zgvh4l-0"
})(["border:0;padding:0;margin:0;overflow:visible;background:transparent;font:inherit;display:flex;align-items:center;justify-content:center;&:hover{cursor:pointer;}&#mousedown{outline:0;}"]);
const Label = styled.span.withConfig({
  displayName: "menu-button__Label",
  componentId: "sc-zgvh4l-1"
})(["display:block;margin-left:", ";color:", ";line-height:1;"], spacing.space8, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText);
const Burger = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "menu-button__Burger",
  componentId: "sc-zgvh4l-2"
})(["height:", ";padding:0 ", ";display:flex;justify-content:center;align-items:center;flex-direction:column;position:relative;"], icons.l, spacing.space8);
const burgerColor = ({
  variant,
  theme
}) => {
  switch (variant) {
    case NavbarVariant.White:
      return theme.typography ? theme.typography.defaultTextInverted : themeLight.typography.defaultTextInverted;
    case NavbarVariant.Default:
    default:
      return theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText;
  }
};
const Span = styled.span.withConfig(propValidationConfig).withConfig({
  displayName: "menu-button__Span",
  componentId: "sc-zgvh4l-3"
})(["width:100%;height:100%;display:block;transition:transform ", " ", ";background:", ";"], speedIn, easeIn, ({
  theme,
  $variant
}) => burgerColor({
  theme: theme,
  variant: $variant
}));
const Line = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "menu-button__Line",
  componentId: "sc-zgvh4l-4"
})(["width:", ";height:2px;transform-origin:center;background:transparent;", ";", ";", ";"], spacing.space20, ({
  $first,
  $isOpen
}) => $first && css(["transform:translateY(-4px);transition:transform ", " ", " ", ";", ""], speedOut, speedIn, easeOut, $isOpen === true && css(["transform:translateY(2px);transition:transform ", " ", ";", "{transform:rotate(45deg);transition:transform ", " ", " ", ";}"], speedIn, easeIn, Span, speedIn, speedIn, easeIn)), ({
  $second,
  $isOpen,
  $variant,
  theme
}) => $second && css(["transition:opacity 0s ", " ", ";background:", ";", ""], speedIn, easeIn, () => burgerColor({
  theme,
  variant: $variant
}), $isOpen === true && css(["opacity:0;transition:opacity 0s ", " ", ";"], speedIn, easeIn)), ({
  $third,
  $isOpen
}) => $third && css(["transform:translateY(4px);transition:transform ", " ", " ", ";", ""], speedOut, speedIn, easeOut, $isOpen === true && css(["transform:translateY(-2px);transition:transform ", " ", ";", "{transform:rotate(-45deg);transition:transform ", " ", " ", ";}"], speedIn, easeIn, Span, speedIn, speedIn, easeIn)));
//# sourceMappingURL=menu-button.js.map